import React from "react"
import {SosTeaser} from "../../../../packages/graphql-layer/src";
import CCOHeadline from "../../fundamentals/CCOHeadline";
import CCORichText from "../../fundamentals/CCORichText/CCORichText";
import CCOLinkable from "../../fundamentals/CCOLinkable";
import CCOContainer from "../../fundamentals/CCOContainer";
import CCOContainer33_66 from "../../fundamentals/CCOContainer33_66";
import {RichTextElement} from "../../fundamentals/CCORichText/CCORichTextHelper";
import CCOResponsivePicture from "../../fundamentals/CCOResponsivePicture";
import {C000DefaultTeaserPictureSettings} from "../../../common/constants/pictureSettings";


export interface Props {
    cmTeasable: SosTeaser
}

function C000DefaultTeaser(props: Props) {
    if (props.cmTeasable.teaserTitle && props.cmTeasable.teaserTitle.length > 0) {
        const leftElement = () => {
            if (props.cmTeasable?.picture === undefined || props.cmTeasable?.picture === null) {
                return;
            }
            return <CCOResponsivePicture pictureSetting={C000DefaultTeaserPictureSettings}
                                         picture={props.cmTeasable?.picture}
                                         imageStyle={{width: "100%", height: "auto"}}
                                         pictureStyle={{width: '100%'}}/>
        }
        return <CCOContainer>
            <CCOLinkable target={props.cmTeasable!}>
                <CCOContainer33_66
                    left={leftElement()}
                    right={
                        <>
                            <CCOHeadline metadataId={props.cmTeasable.id} propertyName='properties.teaserTitle' headline={props.cmTeasable.teaserTitle} type={"h4"} justify={"left"}/>
                            {props.cmTeasable.teaserText ?
                                <CCORichText metadataId={props.cmTeasable.id} propertyName='properties.teaserText'
                                    textAsTree={props.cmTeasable.teaserText!.textAsTree as RichTextElement}/> : null}
                        </>
                    }/>

            </CCOLinkable>
        </CCOContainer>
    } else return null
}

export default C000DefaultTeaser